import { render, staticRenderFns } from "./ImageGalleryOverlay.vue?vue&type=template&id=7e4eb1b5&"
import script from "./ImageGalleryOverlay.vue?vue&type=script&lang=js&"
export * from "./ImageGalleryOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ImageGalleryOverlay.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports